import isEmpty from 'lodash/isEmpty';

export function toCamelCase (str) {
    return str.replace(/^([A-Z])|\s(\w)/g, function(match, p1, p2, offset) {
        if (p2) return p2.toUpperCase();
        return p1.toLowerCase();
    });
}

export function stringToArray (arrayString) {
    try {
      if (typeof arrayString !== 'string') {
        return null;  
      }
  
      if (arrayString.trim() === '[]') {
        return [];
      }
  
      const parsedArray = JSON.parse(arrayString);
  
      if (Array.isArray(parsedArray)) {
        return parsedArray;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
}

export function isString (v) {
    return typeof v === 'string';
}

export function encodedStrToArray(encodedString) {
  if (!encodedString) {
    return [];
  }
  const parts = encodedString.split(',');
  const decodedArray = parts.map(part => decodeURIComponent(part));
  return decodedArray;
}

export function strToArrayTrim(encodedString) {
  if (!encodedString) {
    return [];
  }
  const parts = encodedString.split(',');
  const decodedArray = parts.map(part => part.trim());
  return decodedArray;
}

export function formalize (str) {
  if (!str) {
    return '';
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function fixColor (widget, propName) {
  if (widget[propName] && widget[propName].indexOf('#') === -1) {
      widget[propName] = `#${widget[propName]}`;
  }
}

export function strParamsToArray (strArr) {
    try {
      // Replace single quotes with double quotes to make it valid JSON
      const jsonString = strArr.replace(/'/g, '"');
      // Parse the JSON string into a JavaScript array
      const actualArray = JSON.parse(jsonString);
      // Check if the result is actually an array
      if (Array.isArray(actualArray)) {
        return actualArray;
      } else {
        console.error("Error: Parsed value is not an array.");
        return strToArrayTrim(strArr);
      }
    } catch (error) {
      
      console.error("Error converting string to array:", error);
      return strToArrayTrim(strArr);
    }
}

export function stringToBool (v) {
    if (typeof v === 'string') {
        const lowerStr = v.toLowerCase();
        if (lowerStr === 'true') {
            return true;
        } else if (lowerStr === 'false') {
            return false;
        } else {
        // Handle cases where the string is not 'true' or 'false'
            return undefined; // Or you could throw an error, return null, etc.
        }
    }

    else if (typeof v === 'boolean') {
        return v;
    }
    return false;
}

export function isStringTruthy (str) {
  if (typeof v === 'boolean') return str;
  if (str === undefined || str === null) return false;
  if (typeof str === 'string' && str.toLowerCase() === 'false') {
      return false;
  }
  return true;
}

export function isDatePartsValid (dateStr) {
  if (!isEmpty(dateStr)) {
      const dates = dateStr.split('-');
      if (dates.length >= 3) {
        if (Number(dates[0]) <= 1900) {
          return false;
        }

        if (dates[1].indexOf('00') === 1) {
            return false;
        } 
        if (dates[2].indexOf('00') === 1) {
            return false;
        }
        return true;
      } 
  }
  return false;
}

export function formatArrayToString(array) {
  return `[${array.map(item => `"${item}"`).join(', ')}]`;
}